import Icon from '../../components/Icon.vue'

Icon.register({"regular/map":{"width":576,"height":512,"paths":[{"d":"M508.5 36.2L381.5 92.6 207.2 34.5A48-48 0 0 1 172.5 36.1L28.5 100.1A48-48 0 0 1 0 144V432C0 466.9 36 489.8 67.5 475.8L194.5 419.4 368.8 477.5A48-48 0 0 1 403.5 475.9L547.5 411.9A48-48 0 0 1 576 368V80C576 45.1 540 22.2 508.5 36.2zM360 424L216 376V88L360 136V424zM48 432V144L168 90.7V378.7L48 432zM528 368L408 421.3V133.3L528 80V368z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/map.js
// module id = +q4l
// module chunks = 0